var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectoryAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3093 8C20.2352 8 21.0914 8.33516 21.7813 8.83812C22.2413 9.17343 22.7553 9.88405 23.3235 10.97H39.4125C41.4878 10.9929 42.6965 11.7825 43.0387 13.3388C43.0973 13.6058 42.9284 13.8698 42.6615 13.9285C42.6266 13.9361 42.5909 13.94 42.5552 13.94H6.51087C6.23749 13.94 6.01587 13.7184 6.01587 13.445C6.01587 13.4448 6.01587 13.4446 6.01587 13.4445L6.01855 10.97C6.01855 9.37126 7.60106 8.05701 9.5827 8.00181L9.71249 8H19.3093Z",
    fill: "#9EBAF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51442 14.93H42.6106C42.884 14.93 43.1056 15.1516 43.1056 15.425C43.1056 15.4313 43.1055 15.4377 43.1052 15.444L42.2082 38.7661C42.1673 39.8292 41.2936 40.67 40.2297 40.67H8.89532C7.83141 40.67 6.95767 39.8292 6.91678 38.7661L6.01978 15.444C6.00927 15.1708 6.22221 14.9409 6.49539 14.9304C6.50173 14.9301 6.50807 14.93 6.51442 14.93Z",
    fill: "#C9DBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryAgent);
export default __webpack_public_path__ + "static/media/directoryAgent.6e88f559.svg";
export { ForwardRef as ReactComponent };